import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from 'widgets/Select/Select';

const SORT_PARAMETERS =
  [{ value: 'MOST_RECENT', name: 'Most recent' },
    { value: 'HIGHEST_RATED', name: 'Highest rated' },
    { value: 'LOWEST_RATED', name: 'Lowest rated' },
    { value: 'MOST_HELPFUL', name: 'Most helpful' }];

export default class ReviewsSort extends PureComponent {
  static propTypes = {
    onSortOrderChange: PropTypes.func.isRequired,
    sortOrder: PropTypes.string,
  };

  render() {
    const { sortOrder, onSortOrderChange } = this.props;
    return (
      <div className="bop-sortOrder__wrapper">
        <span className="bop-sortOrder__label">Sort by: </span>
        <Select
          name="sortOrder"
          onChange={(name, value) => {
            onSortOrderChange(value);
          }}
          value={sortOrder}
          disabled={false}
          options={SORT_PARAMETERS}
          small
          className="bop-sortOrder"
        />
      </div>);
  }
}
